exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-red[data-v-c7aff52e] {\n    border-color: red;\n    border-width: 2px;\n}\n.h-100[data-v-c7aff52e] {\n    height: 100%;\n}\n", ""]);

// exports
